import { useAppSelector } from '@customer/store/hooks';
import { BarChartByProps } from './config';
import {
  isGlobalTimeRange,
  PerformanceTimeRangeFilters,
  usePerformanceTimeRangeFilters,
} from '@customer/store/slices/globalSlice';
import { isPerformanceStatsScenario } from '@customer/store/apis/scenariosApi';

type ChartScenarioTimeFilters = PerformanceTimeRangeFilters;

export const useChartScenarioTimeFilters = ({
  scenario,
  includeTimeRange = false,
  timeRange,
}: Pick<
  BarChartByProps,
  'scenario' | 'includeTimeRange' | 'timeRange'
>): ChartScenarioTimeFilters => {
  const globalTimeRange = useAppSelector(state => state.global.timeRange);

  const performanceTimeRangeFilters: PerformanceTimeRangeFilters = usePerformanceTimeRangeFilters();

  if (includeTimeRange) {
    // Fixed timeRange props take precedence.
    if (
      typeof timeRange !== 'undefined' &&
      (isGlobalTimeRange(timeRange) || isPerformanceStatsScenario(scenario))
    ) {
      return { timeRange };
    }

    // Include performance time range values for relevant scenarios.
    if (isPerformanceStatsScenario(scenario)) {
      return performanceTimeRangeFilters;
    }

    // Default to providing the global time range.
    return { timeRange: globalTimeRange };
  }

  return { timeRange: undefined };
};
